import axios from './axios';
import { SERVICE_URL } from '@/config';

const BASE_URL = `${SERVICE_URL}/bulk-registration`;

export default {
    getRecordsByFileUrl(fileUrl : string, eventId : string){
        return axios.get(`${BASE_URL}/${eventId}/records?fileUrl=${fileUrl}`);
    }
}